import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { goToTop } from '_helpers';
import { zeroPad } from 'react-countdown';
import images from '_images';
import eventTracker from '../../../../helpers/eventTracker';
import events from '../../events';
import SecondsCounter from './components/SecondsCounter';
import Game from './components/Game';
import StaticGameScreen from './components/StaticGameScreen';
import CountdownModal from './components/CountdownModal';

const Container = styled.div`
  margin-top: ${Number(window.statusBarHeight || 0)}px;
  padding-bottom: 10px;
`;

const OnBoardingContainer = styled.div`
  width: 100%;
`;

const Image = styled.img`
  height: 30%;
  width: 50%;
  visibility: hidden;
  display:none;
`;

const PleaseWait = styled.h2`
  font-size: 2vh;
`;

const Loading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 600px;
`;

const LoadingCircle = styled.div`
  overflow: hidden;
  border: 10px solid #f3f3f3;
  border-top: 10px solid #3498db;
  border-radius: 50%;
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '280px' : '100px')};
  height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '280px' : '100px')};
  animation: spin 1s linear infinite;
  transition: width 0s linear;
  animation-name: in-out;
  animation-timing-function: linear;

  @keyframes in-out {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const CountDownContainer = styled.div`
  display: flex;
  margin-left: auto;
  background-color: #5bc236;
  border-radius: 40px;
  padding: 2px 5px;
`;

const TimerImage = styled.img`
  height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
`;

const TopContainer = styled.div`
  padding: 0px 5px 5px 5px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #E7ECEF;
  box-shadow: inset 0 0 0 1000px rgba(256,256,256,1);
`;

const Title = styled.div`
  display:flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')};
  color: rgba(64, 64, 64, 1);
  font-weight: bold !important;
`;

const Arrow = styled.button`
  display: flex; 
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 0;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  line-height: normal;
  background-color: ${({ background }) => background} ;

  &:hover {
    border-radius: 50%;
    background-color: #EBEBF0;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;

/**
 * Display Recycle RIGHT game.
 * If it is user's first time to play the game, it will show onBoarding screens,
 * else, it will start the game
 *
 * @author: Ashkan
 * @param {object} recycleRightData Recycle RIGHT game's data
 * @returns {object}
 */

const RecycleRIGHT = ({
  windowsWidth, setStartGame, setDisplayedContent, recycleRightData
}) => {
  /**
   * Create variables to check the on boarding status
   * if the user already saw the oboarding screen for tutorial will navigate to the game
   * in order to check user saw the onbaordin, onBoardingState key from local host will be checked
   */

  const onBoardingState = localStorage.getItem('onBoardingState');
  const [onBoardingStatus, setOnBoardingStatus] = useState(
    // onBoardingState ? 'inGame' : 'firstTutorialScreen'
    'inGame'
  );
  const [countDownWaiting, setCountDownWaiting] = useState(false);

  const goNext = () => {
    if (onBoardingStatus === 'firstTutorialScreen') {
      setOnBoardingStatus('secondTutorialScreen');
    } else {
      localStorage.setItem('onBoardingState', 'inGame');
      setOnBoardingStatus('inGame');
    }
  };

  const sampleDoneMaterials = [
    'correct-252', 'correct-610', 'wrong-34', 'wrong-2997', 'wrong-192',
    'correct-445', 'correct-81', 'wrong-2806', 'wrong-2969', 'correct-2827',
    'correct-2910', 'wrong-28', 'correct-35', 'correct-359'
  ];

  /**
   * Before starting the game all the materials images (by their urls) will be loaded.
   */
  const loadedImages = [];
  const gameImages = [];
  const [isLoaded, setIsLoaded] = useState(false);
  Object.keys(recycleRightData).forEach((key) => {
    recycleRightData[key].forEach((element) => gameImages.push(element.mat_image));
  });
  const onLoad = (index) => {
    loadedImages.push(index);
    if (loadedImages.length === gameImages.length) {
      setIsLoaded(true);
      setTimeout(() => {
        setCountDownWaiting(true);
      }, 6000);
    }
  };

  const goBackHandler = () => {
    setOnBoardingStatus('firstTutorialScreen');
    setStartGame(false);
    setDisplayedContent();
    goToTop();

    // track event
    eventTracker(events.DZ_RR_CLOSE_TAP, {
      level: 1,
      mat_id: recycleRightData.level_1_materials[0].mat_id,
      index: 0
    });
  };

  return (
    <Container>
      <>
        {(onBoardingStatus !== 'inGame') && (
          <TopContainer>
            <Title windowsWidth={windowsWidth}>
              <Arrow background="#fff" onClick={goBackHandler}>
                &#8678;
              </Arrow>
              {_('education.recycle_right')}
            </Title>
            <CountDownContainer>
              <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} windowsWidth={windowsWidth} />
              <TimerImage
                src={images.recycleRight.timer}
                windowsWidth={windowsWidth}
              />
            </CountDownContainer>
          </TopContainer>
        )}
        <OnBoardingContainer onClick={goNext}>
          {
            onBoardingStatus === 'firstTutorialScreen' && (
              <StaticGameScreen
                questionIndex={4}
                currentLevel={1}
                modalVisible={false}
                doneMaterials={sampleDoneMaterials}
                passedMaterialsCount={10}
                windowsWidth={windowsWidth}
                isOnBoarding="firstOnBoarding"
              />
            )
          }
          {
            onBoardingStatus === 'secondTutorialScreen'
            && (
              <StaticGameScreen
                questionIndex={4}
                currentLevel={1}
                modalVisible={false}
                doneMaterials={sampleDoneMaterials}
                passedMaterialsCount={10}
                windowsWidth={windowsWidth}
                setStartGame={setStartGame}
                setDisplayedContent={setDisplayedContent}
                isOnBoarding="secondOnBoarding"
              />
            )
          }
        </OnBoardingContainer>
      </>
      {
        onBoardingStatus === 'inGame'
        && (
          <>
            {gameImages.map((url, index) => (
              <Image src={url} onLoad={() => onLoad(index)} key={url} />
            ))}
            {!isLoaded ? (
              <Loading>
                <LoadingCircle />
                <PleaseWait>{_('recycleRight.please_wait')}</PleaseWait>
              </Loading>
            ) : (
              <>
                {
                  !countDownWaiting && (
                    <>
                      <CountdownModal />
                      <StaticGameScreen
                        questionIndex={0}
                        currentLevel={0}
                        modalVisible={false}
                        doneMaterials={[]}
                        passedMaterialsCount={0}
                        setStartGame={setStartGame}
                        setDisplayedContent={setDisplayedContent}
                        windowsWidth={windowsWidth}
                      />
                    </>
                  )
                }
                {
                  countDownWaiting && (
                    <Game
                      windowsWidth={windowsWidth}
                      setStartGame={setStartGame}
                      setDisplayedContent={setDisplayedContent}
                    />
                  )
                }
              </>
            )}
          </>
        )
      }
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.education.recycle_right
  })
)(RecycleRIGHT);
